import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Text,
} from '@shared/components';

interface SubmitReviewErrorModalProps {
  open: boolean;
  missingQuestionVerdictCount: number;
  onClose: () => void;
}

export default function SubmitReviewErrorModal(props: Readonly<SubmitReviewErrorModalProps>) {
  const { open, missingQuestionVerdictCount, onClose } = props;

  return (
    <Dialog open={open} onClose={onClose} maxWidth='xs'>
      <DialogTitle>Incomplete Review</DialogTitle>
      <DialogContent>
        <Text>คุณยังรีวิวชุดข้อสอบนี้ไม่ครบทุกข้อ</Text>
        <Text>
          จำนวนข้อที่ยังไม่ได้รีวิว:{' '}
          <Text variant='body1Semibold' component='span'>
            {missingQuestionVerdictCount} ข้อ
          </Text>
        </Text>
        <Text>กรุณารีวิวให้ครบก่อนส่ง</Text>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Back to Review</Button>
      </DialogActions>
    </Dialog>
  );
}
